import { render, staticRenderFns } from "./Payslips.vue?vue&type=template&id=5871ff69&scoped=true&"
import script from "./Payslips.vue?vue&type=script&lang=js&"
export * from "./Payslips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871ff69",
  null
  
)

export default component.exports